import { useEffect, useState } from 'react';

import pushRouter from 'hooks/useRouterHelper';

import IndividualStudyBar from './IndividualStudyBar';
import IStudyQuery from '../../../IURLQuery';

import './StudyBottomBar.scoped.scss';

const bottomBarItems = [
  // {
  //     name: 'Announcements',
  //     path: '/study',
  //     param: '?section=announcments',
  //     icon: null,
  // },
  {
    name: 'Notes',
    path: '/study',
    param: 'notes',
    icon: null,
  },
  {
    name: 'Discussions',
    path: '/study',
    param: 'discussions',
    icon: null,
  },
  // {
  //     name: 'This Lecture',
  //     path: '/study',
  //     param: '?section=current',
  //     icon: <ExpandArrow />,
  // },
];

const StudyBottomBar: React.FC = () => {
  const [lesson, setLesson] = useState(null);
  const { query } = pushRouter<IStudyQuery>();
  useEffect(() => {
    if (query && query.lesson && query.lesson !== 'null') {
      setLesson(query.lesson as string);
    } else {
      setLesson(null);
    }
  }, [window.location.search]);

  return (
    <>
      {lesson && (
        <div className="study-bottom-bar-container">
          <div className="sections">
            {bottomBarItems.map((item, i) => {
              const { name, param, icon } = item;
              return <IndividualStudyBar key={i} name={name} param={param} icon={icon} />;
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default StudyBottomBar;
